var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Curved/Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87054 18.0516C6.79402 18.0516 4.16675 17.5728 4.16675 15.6555C4.16675 13.7382 6.77735 11.9683 9.87054 11.9683C12.9471 11.9683 15.5743 13.7211 15.5743 15.6384C15.5743 17.5549 12.9637 18.0516 9.87054 18.0516Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8646 9.31136C11.8835 9.31136 13.5199 7.675 13.5199 5.65606C13.5199 3.63712 11.8835 2 9.8646 2C7.84566 2 6.20852 3.63712 6.20852 5.65606C6.20172 7.66818 7.82672 9.30455 9.83884 9.31136C9.84793 9.31136 9.85627 9.31136 9.8646 9.31136Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInput);
export default __webpack_public_path__ + "static/media/profile-input.c1569f638504fea10cd7aaf649e2a131.svg";
export { ForwardRef as ReactComponent };